import { BrowserModule } from '@angular/platform-browser';
import { DEFAULT_CURRENCY_CODE, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, registerLocaleData } from '@angular/common';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig, CurrencyMaskModule } from 'ng2-currency-mask';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CoreModule } from '../../../modules/src/lib/core/core.module';
import localeFrCa from '@angular/common/locales/fr-CA';
import { RootComponent } from './components/root/root.component';
import { QuestionnairesModule } from '../../../modules/src/lib/questionnaires/questionnaires.module';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { TopNavbarComponent } from './components/top-navbar/top-navbar.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { LoggedOutComponent } from './pages/logged-out/logged-out.component';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AdvancedAuthModule } from '../../../modules/src/lib/advanced-auth/advanced-auth.module';
import {
  DashboardQuestionnaireComponent,
} from './components/dashboard-questionnaire/dashboard-questionnaire.component';
import { QuestionnaireCompletedComponent } from './pages/questionnaire-completed/questionnaire-completed.component';
import { provideTranslateService } from '@ngx-translate/core';
import {MagienoAdvancedFormsModule} from "@magieno/angular-advanced-forms";

registerLocaleData(localeFrCa);

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  decimal: '.',
  precision: 2,
  prefix: '',
  suffix: '',
  thousands: ' ',
};

@NgModule({
  declarations: [
    AppComponent,
    RootComponent,
    LayoutComponent,
    WelcomeComponent,
    TopNavbarComponent,
    DashboardComponent,
    DashboardQuestionnaireComponent,
    LogoutComponent,
    LoggedOutComponent,
    NotAuthorizedComponent,
    QuestionnaireCompletedComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    // Optitax Modules
    AuthModule.forRoot({
      domain: window['optitax'].configuration.auth0.domain,
      clientId: window['optitax'].configuration.auth0.clientId,
      authorizationParams: {
        scope: 'openid profile email read:all',
        redirect_uri: window.location.origin + '/auth-callback',
      },
      httpInterceptor: {
        allowedList: [
          {
            uriMatcher: (uri: string) => {
              if (uri.includes('/api/public')) {
                return false;
              }
              return uri.includes('optitax.ca/api');
            },
            tokenOptions: {
              authorizationParams: {
                audience: environment.auth0Audience,
                scope: 'openid profile email read:all',
              },
            },
          }],
      },
      errorPath: '/auth-error',
    }),
    AdvancedAuthModule,
    MagienoAdvancedFormsModule,
    CoreModule,
    QuestionnairesModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
    FontAwesomeModule], providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'CAD' },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    // Configs
    // Parameters
    {
      provide: 'environment.api.url',
      useValue: environment.apiUrl,
    },
    {
      provide: 'environment.auth0.audience',
      useValue: environment.auth0Audience,
    },
    {
      provide: 'environment.is-debug',
      useValue: environment.isDebug,
    },
    {
      provide: 'environment.name',
      useValue: environment.name,
    },
    {
      provide: 'environment.production',
      useValue: environment.production,
    },
    {
      provide: 'environment.flags',
      useValue: environment.flags,
    },
    {
      provide: 'environment.logging.severityType',
      useValue: environment.logging.severityType,
    },
    provideHttpClient(withInterceptorsFromDi()),

    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'fr',
      lang: 'fr',
    }),
  ],
})
export class AppModule {
}
